import React from 'react'
import RegisterForm from 'components/Forms/RegisterForm/RegisterForm'
import RegisterEmployeeForm from 'components/Forms/RegisterEmployeeForm/RegisterEmployeeForm'
import { Login } from 'pages'
import { Navigate } from 'react-router-dom'
import AccountSettingsPage from 'pages/AccountSettingsPage/AccountSettingsPage'
import AdminPage from 'pages/AdminPage/AdminPage'
import ReportCard from 'pages/ReportCard/ReportCard'
import EmployeeCard from 'pages/EmployeeCard/EmployeeCard'
import AdminPanelPage from 'pages/AdminPanelPage/AdminPanelPage'
import ReportsPage from 'pages/ReportsPage/ReportsPage'
import DocflowPage from 'pages/Docflow/DocflowPage'
import RequestsPage from 'pages/RequestsPage/RequestsPage'
import DriverRegistration from 'pages/DriverRegistration/DriverRegistration'
export const routes = [
  { path: '/', component: <Login />, public: true },
  { path: '/driver-register/', component: <DriverRegistration />, public: true },
  { path: '/driver-register-admin/', component: <DriverRegistration adminMode />, access: 'drivers_edit' },
  { path: '/requests/', component: <RequestsPage />, access: 'requests' },
  { path: '/adminpanel/', component: <AdminPanelPage />, access: 'admin' },
  { path: '/reports/', component: <ReportsPage />, access: 'reports' },
  { path: '/report-card/', component: <ReportCard />, access: 'operational' },
  { path: '/account-settings/', component: <AccountSettingsPage /> },
  { path: '/personalcard/', component: <Navigate to="/account-settings/" replace /> },
  { path: '/employee-card/', component: <EmployeeCard />, access: 'legacy' },
  { path: '/docflow/', component: <DocflowPage />, access: 'legacy' },
  { path: '/register_employee/', component: <RegisterEmployeeForm />, access: 'legacy' },
  { path: '/register_person/', component: <RegisterForm />, access: 'users' },
  { path: '/admin_organizations/', component: <AdminPage />, access: 'legacy' },
]
